import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from './../../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../../../services/mysql.service';

import { Job } from '../../../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';

import { Subscription } from 'rxjs';



import { FileUploaderService } from './../../../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../../../services/global-functions.service';

import { SubjectBillingItem } from '../../../../../shared/models/subjectBillingItem.model';

import { SubjectInvoiceItem } from '../../../../../shared/models/subjectInvoiceItem.model';

import { SubjectWorkOrderItem } from '../../../../../shared/models/subjectWorkOrderItem.model';

import { SubjectCostItem } from './../../../../../shared/models/subjectCostItem.model';

@Component({
  selector: 'app-add-subject-cost-item-widget',
  templateUrl: './add-subject-cost-item-widget.component.html',
  styleUrls: ['./add-subject-cost-item-widget.component.css']
})
export class AddSubjectCostItemWidgetComponent implements OnInit, OnChanges {

  @Input() job_id;
  @Input() subject_id;
  @Input() subject_number;
  @Input() job_number;
  @Input() agent_id;
  @Input() agent_full_name;

  @Input() is_create_invoice_item =  false; // false by defualt... now make the component work for both invoices and stand alone.
  @Input() is_update_invoice_item =  false; // false by defualt... now make the component work for both invoices and stand alone.

  // @Input() is_create_invoice_item =  false; // false by defualt... now make the component work for both invoices and stand alone.
  // @Input() is_update_invoice_item =  false; // false by defualt... now make the component work for both invoices and stand alone.

  @Input() invoice_id?; // impliments on changes.
  @Input() invoice_number?; // impliments on changes.

  @Input() work_order_id?; // impliments on changes.
  @Input() work_order_number?; // impliments on changes.

  // setup as observable?
  @Input() item_id?: Observable<any[]>; // impliments on changes.
  @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'side'; // side | abstract | full
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  @Output('closeParentModel2') closeParentModel2: EventEmitter<any> = new EventEmitter();
  @Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();
  @Output('refreshInvoiceItemsBelow') refreshInvoiceItemsBelow: EventEmitter<any> = new EventEmitter();
    @Output('refreshWorkOrderItemsBelow') refreshWorkOrderItemsBelow: EventEmitter<any> = new EventEmitter();

  job: Object;
  billing_tasks: Object;
  // model: SubjectBillingItem;
  model: any;

  cost_tasks: any;

  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  job_type: Object;
  job_type_name: any;
  job_type_id: any;
  job_type_location: Object;
  job_type_location_name: any;
  job_type_court: Object;
  job_type_court_name: any;
  new_subject_billing_item_id: any;
  returned_subject_billing_item_id: any;
  new_invoice_item_id: any;
  returned_invoice_item_id: any;
  invoiceItemsList: any[];
  invoiceItemsList2: SubjectInvoiceItem;
  workOrderItemsList2: SubjectWorkOrderItem;
  new_subject_cost_item_id: any;
  returned_subject_cost_item_id: any;
  new_work_order_item_id: any;
  returned_work_order_item_id: any;
  assignedBrandList: Object;
  cost_tasks2: Object;
  model2: { agent_id: any; subject_id: number; job_id: number; cost_task_name: string; myob_tax_code_id: any; myob_account_code_id: any; cost_task_description: any; cost_task_fee: any; cost_task_id: any; subject_number: any; agent_full_name: any; };
  cost_task_name: any;


 constructor(
   private http: HttpClient, private _demoService: DemoService,
   private route: ActivatedRoute, public toastr: HotToastService,
    vcr: ViewContainerRef, private router: Router,
    public HttpClient:HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService
 ) {




  }

  // check for changes. to load data.
  ngOnChanges(changes) {
   if (changes.subject_id) {
     // deal with asynchronous Observable result
   //  this.job_id = changes.item_id.currentValue;
     this.getJob(this.job_id);
     this.model = SubjectCostItem;
    //  this.getBillingTasks();
     this.getCostTasks();
      this.getJob(this.job_id);

   }
 }


 ngOnInit() {
 }

 // Functions
getJob(job_id) {
 this._demoService.getJobID(job_id).subscribe(
    data => { this.job = data;
     let res = data[0];
     // Run the job data queries.
     this.job_type_id = res.job_type_id;
         // naming
    this.getJobType(res.job_type_id);
    this.getJobTypeLocation(res.job_type_location_id);
    this.getJobTypeCourt(res.job_type_court_id);
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
};


 // File Nameing
 getJobType(job_type_id) {
  this._demoService.getJobType(job_type_id).subscribe(
     data => { this.job_type = data;
      let res = data[0];
      this.job_type_name = res.job_type_name;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobTypeLocation(job_type_location_id){
  this._demoService.getJobTypeLocation(job_type_location_id).subscribe(
    data => { this.job_type_location = data;
   let res = data[0];
   this.job_type_location_name = res.job_type_location_name;

   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
 }


 getJobTypeCourt(job_type_court_id){
  this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
    data => {  this.job_type_court = data;
      let res = data[0];
      this.job_type_court_name = res.job_type_court_name;
     },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
 }



getBillingTasks() {
  this._demoService.getBillingTasks().subscribe(
     data => { this.billing_tasks = data;
      let res = data[0];
      // Run the job data queries.
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

//  getAndSetBillingTask(billing_task_id) {
//   this._demoService.getBillingTask(billing_task_id).subscribe(
//      data => { this.billing_tasks = data;
//       let res = data[0];
//       // create insert model
//   this.model = {
//     subject_id: this.subject_id,
//     job_id: this.job_id,
//     billing_task_name: this.subject_number + ' - ' + res.billing_task_name + ': ' + this.job_type_name + ' ' + this.job_type_location_name
//      + ' ' + this.job_type_court_name,
// myob_tax_code_id: res.myob_tax_code_id,
// myob_account_code_id: res.myob_account_code_id,
// billing_task_description: res.billing_task_description,
// billing_task_fee: res.billing_task_fee,
// billing_task_id: res.billing_task_id,
// subject_number: this.subject_number,
// job_number: this.job_number,
//   };

//   this.addSubjectBillingItem(this.model);

//     },
//      err => console.error(err),
//      // () => console.log('done loading Trace Types')
//    );
//  }





 getCostTasks() {
  this._demoService.getCostTasks().subscribe(
     data => { this.cost_tasks = data;
      let res = data[0];
      // Run the job data queries.
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getAndSetCostTask(cost_task_id) {
  this._demoService.getCostTask(cost_task_id).subscribe(
     data => { this.cost_tasks = data;
      let res = data[0];

      const random_key = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string


 // Invoice Billing Items Fix 2023 - only name process service full name.
 this.cost_task_name; 
 if (this.job_type_id != 1){
//  this.cost_task_name =  this.subject_number + ' - ' + res.cost_task_name;
 this.cost_task_name =  this.subject_number + ' - ' +  this.job_type_name + ' - ' +  res.cost_task_name; 
     }

 if (this.job_type_id == 1 ) {
  this.cost_task_name =  this.subject_number + ' - ' + res.cost_task_name + ': ' + this.job_type_name + ' ' + this.job_type_location_name
  + ' ' + this.job_type_court_name;
  }



  // :: make up the item -- ned to set as 1 and work out fees etc for basic holdier information
let tax_percent;
let tax_value = 0;
 if(res.myob_tax_code_id == 1 || res.myob_tax_code_id == 4 ) {
   tax_percent = 10;
   tax_value = (res.cost_task_fee / (100 / tax_percent));
 }
 if(res.myob_tax_code_id == 2 || res.myob_tax_code_id == 5 ) {
   tax_percent = 0;
   tax_value = 0;
 }

      // create insert model
  this.model = {
    subject_id: this.subject_id,
    job_id: this.job_id,
    // cost_task_name: this.subject_number + ' - ' + res.cost_task_name + ': ' + this.job_type_name + ' ' + this.job_type_location_name
    //  + ' ' + this.job_type_court_name + '  [k: ' + random_key + ']',
cost_task_name: this.cost_task_name,
myob_tax_code_id: res.myob_tax_code_id,
myob_account_code_id: res.myob_account_code_id,
cost_task_description: res.cost_task_description,
cost_task_fee: res.cost_task_fee,
cost_task_id: res.cost_task_id,
subject_number: this.subject_number,
job_number: this.job_number,
agent_id: this.agent_id,
agent_full_name: this.agent_full_name,
// qty:res.qty,
qty:1, // as not not set as yet.
unit_price: res.cost_task_fee, // not set yet
tax:tax_value,
// total:res.cost_task_fee // as it is not set yet.
total: +res.cost_task_fee + +tax_value,
  };

//  this.addSubjectBillingItem(this.model);
  

console.log('Model to Push: ' + JSON.stringify(this.model));
this.addSubjectCostItem(this.model);

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }
 

 addSubjectCostItem(model) {
  this._demoService.addSubjectCostItem(model).subscribe(
     data => { // this.billing_tasks = data;
     // let res = data[0];
      // Run the job data queries.
      this.toastr.success('Cost Item Added');
      this.refreshParentGrid.emit();
      this.closeParentModel.emit();
      this.refreshSujectWorkOrderPage(this.subject_id); // so refresh entire page instead.
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 addSubjectBillingItem(model) {
  this._demoService.addSubjectBillingItem(model).subscribe(
     data => { // this.billing_tasks = data;
     // let res = data[0];
      // Run the job data queries.
      this.toastr.success('Billing Item Added');
      this.refreshParentGrid.emit();
      this.closeParentModel.emit();
      this.refreshSujectWorkOrderPage(this.subject_id); // so refresh entire page instead.
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



//  getAndSetBillingTaskFromInvoice(billing_task_id) {
//   this._demoService.getBillingTask(billing_task_id).subscribe(
//      data => { this.billing_tasks = data;
//       let res = data[0];
//       // create insert model
//   this.model = {
//     subject_id: this.subject_id,
//     job_id: this.job_id,
//     billing_task_name: this.subject_number + ' - ' + res.billing_task_name + ': ' + this.job_type_name + ' ' + this.job_type_location_name
//      + ' ' + this.job_type_court_name,
// myob_tax_code_id: res.myob_tax_code_id,
// myob_account_code_id: res.myob_account_code_id,
// billing_task_description: res.billing_task_description,
// billing_task_fee: res.billing_task_fee,
// billing_task_id: res.billing_task_id,
// subject_number: this.subject_number,
// job_number: this.job_number,
//   };

//   this.addSubjectBillingItemFromInvoice(this.model);

//     },
//      err => console.error(err),
//      // () => console.log('done loading Trace Types')
//    );
//  }

 getAndSetCostTaskFromInvoice(cost_task_id) {
  this._demoService.getCostTask(cost_task_id).subscribe(
     data => { this.cost_tasks = data;
      let res = data[0];
      // create insert model

 // Invoice Billing Items Fix 2023 - only name process service full name.
 this.cost_task_name; 
 if (this.job_type_id != 1){
//  this.cost_task_name =  this.subject_number + ' - ' + res.cost_task_name;
 this.cost_task_name =  this.subject_number + ' - ' +  this.job_type_name + ' - ' +  res.cost_task_name; 
     }

 if (this.job_type_id == 1 ) {
  this.cost_task_name =  this.subject_number + ' - ' + res.cost_task_name + ': ' + this.job_type_name + ' ' + this.job_type_location_name
  + ' ' + this.job_type_court_name;
  }


// :: make up the item -- ned to set as 1 and work out fees etc for basic holdier information
let tax_percent;
let tax_value = 0;
 if(res.myob_tax_code_id == 1 || res.myob_tax_code_id == 4 ) {
   tax_percent = 10;
   tax_value = (res.cost_task_fee / (100 / tax_percent));
 }
 if(res.myob_tax_code_id == 2 || res.myob_tax_code_id == 5) {
   tax_percent = 0;
   tax_value = 0;
 }


  this.model = {
    subject_id: this.subject_id,
    job_id: this.job_id,
    cost_task_name: this.cost_task_name,
myob_tax_code_id: res.myob_tax_code_id,
myob_account_code_id: res.myob_account_code_id,
cost_task_description: res.cost_task_description,
cost_task_fee: res.cost_task_fee,
cost_task_id: res.cost_task_id,
subject_number: this.subject_number,
job_number: this.job_number,
agent_id: this.agent_id,
// new added feb 2023
qty:1, // as not not set as yet.
unit_price:res.unit_price,
tax:tax_value,
// total:res.cost_task_fee // as it is not set yet.
total: +res.cost_task_fee + +tax_value, // feb 10 2023
  };

  this.addSubjectCostItemFromInvoice(this.model);

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 
 addSubjectCostItemFromInvoice(model) {
  this._demoService.addSubjectCostItem(model).subscribe(
     data => { // this.billing_tasks = data;
     // let res = data[0];
      // Run the job data queries.
      this.toastr.success('Cost Item Added');
      

      // :: TODO!!!!
      // :: Need to refresh the invoice_items_list in parent module??
      
      // :: now hide the invoice modal;
      this.closeParentModel2.emit(null);
      this.refreshParentGrid.emit(); // did not work?
      this.refreshWorkOrderItemsBelow.emit(); // refreshed invoice list in below window. from modal template component.
     this.refreshSujectWorkOrderPage(this.subject_id); // so refresh entire page instead.

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 addSubjectBillingItemFromInvoice(model) {
  this._demoService.addSubjectBillingItem(model).subscribe(
     data => { // this.billing_tasks = data;
     // let res = data[0];
      // Run the job data queries.
      this.toastr.success('Billing Item Added');
      

      // :: TODO!!!!
      // :: Need to refresh the invoice_items_list in parent module??
      
      // :: now hide the invoice modal;
      this.closeParentModel2.emit(null);
      this.refreshParentGrid.emit(); // did not work?
     this.refreshSujectWorkOrderPage(this.subject_id); // so refresh entire page instead.

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 refreshSujectWorkOrderPage(subject_id){
  this.router.navigateByUrl('admin', {skipLocationChange: true}).then(() =>
                this.router.navigate(['/admin/jobs/subject/cost/' + subject_id + '']));

}







// getAndSetBillingTaskFromInvoiceUpdate(billing_task_id) {

//   this._demoService.getBillingTask(billing_task_id).subscribe(
//      data => { this.billing_tasks = data;
//       let res = data[0];
//       // create insert model
//   this.model = {
//     subject_id: this.subject_id,
//     job_id: this.job_id,
//     billing_task_name: this.subject_number + ' - ' + res.billing_task_name + ': ' + this.job_type_name + ' ' + this.job_type_location_name
//      + ' ' + this.job_type_court_name,
// myob_tax_code_id: res.myob_tax_code_id,
// myob_account_code_id: res.myob_account_code_id,
// billing_task_description: res.billing_task_description,
// billing_task_fee: res.billing_task_fee,
// billing_task_id: res.billing_task_id,
// subject_number: this.subject_number,
// job_number: this.job_number,
//   };


// // :: make up the item
// // let tax_percent;
// // let tax_value = 0;
// //  if(res.myob_tax_code_id == 1) {
// //    tax_percent = 10;
// //    tax_value = (res.billing_task_fee / (100 / tax_percent));
// //  }
// //  if(res.myob_tax_code_id == 2) {
// //    tax_percent = 0;
// //    tax_value = 0;
// //  }

//   // this.invoiceItemsList2 = {
//   //   invoice_number: this.invoice_number,
//   //   invoice_id: this.invoice_id,
//   //   billing_task_id: res.billing_task_id,
//   //   subject_billing_item_id: res.subject_billing_item_id,  // need to ge this to fix !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//   //   billing_task_name: res.billing_task_name,
//   //   myob_tax_code_id: res.myob_tax_code_id,
//   //   myob_account_code_id: res.myob_account_code_id,
//   //   billing_task_fee: res.billing_task_fee,
//   //   billing_task_description: res.billing_task_description,
//   //   subject_id: this.subject_id,
//   //   subject_number: this.subject_number,
//   //   job_id: this.job_id,
//   //   job_number: this.job_number,
//   //   qty: 1,
//   //   unit_price: res.billing_task_fee,
//   //   tax: tax_value,
//   //   total: res.billing_task_fee,
//   //         };

//   this.addSubjectBillingItemFromInvoiceUpdate(this.model);


//      // TOD:::
// // :: Add for Update to insert subjectBillingItems into invoiceItems.
//    // :: add the items
// //   this.addSubjectInvoiceItem(this.invoiceItemsList2, this.invoice_id);
//    // :: Update the status of the subjectBillingItems because we added them to the invoice items database

//   //  setTimeout( () => {  }, 0 );


//     },
//      err => console.error(err),
//      // () => console.log('done loading Trace Types')
//    );
//  }


 
getAndSetCostTaskFromWorkOrderUpdate(cost_task_id) {
  this._demoService.getCostTask(cost_task_id).subscribe(
     data => { this.cost_tasks2 = data;      // changed from cost_tasks as it was refreshing the already OnLoad loaded cost items on click.
      let res = data[0];
      // create insert model
 // Invoice Billing Items Fix 2023 - only name process service full name.

 console.log('res.taxcode_id. ' + res.myob_tax_code_id)
 this.cost_task_name; 
 if (this.job_type_id != 1){
//  this.cost_task_name =  this.subject_number + ' - ' + res.cost_task_name;
this.cost_task_name =  this.subject_number + ' - ' +  this.job_type_name + ' - ' +  res.cost_task_name; 
     }

 if (this.job_type_id == 1 ) {
  this.cost_task_name =  this.subject_number + ' - ' + res.cost_task_name + ': ' + this.job_type_name + ' ' + this.job_type_location_name
  + ' ' + this.job_type_court_name;
  }

  // :: make up the item -- ned to set as 1 and work out fees etc for basic holdier information
  let tax_percent;
  let tax_value = 0;
   if(res.myob_tax_code_id == 1 || res.myob_tax_code_id == 4 ) {
     tax_percent = 10;
     tax_value = (res.billing_task_fee / (100 / tax_percent));
   }else{
  //  if(res.myob_tax_code_id == 2 || res.myob_tax_code_id == 5 ) { // updated so that everything else feb 24/2/24
     tax_percent = 0;
     tax_value = 0;
   }

 
   this.model = {
          agent_id: this.agent_id,
          subject_id: this.subject_id,
          job_id: this.job_id,
          cost_task_name: this.cost_task_name,
      myob_tax_code_id: res.myob_tax_code_id,
      myob_account_code_id: res.myob_account_code_id,
      cost_task_description: res.cost_task_description,
      cost_task_fee: res.cost_task_fee,
      cost_task_id: res.cost_task_id,
      subject_number: this.subject_number,
      agent_full_name: this.agent_full_name,
      // new 2023
// qty:res.qty,
qty:1, // as not not set as yet.
unit_price:res.unit_price,
tax:tax_value,
// total:res.billing_task_fee // as it is not set yet.
total: +res.cost_task_fee + +tax_value, // feb 10 2023

        };

        
        console.log('MOdel: ' + JSON.stringify(this.model));
 

  this.addSubjectCostItemFromWorkOrderUpdate(this.model);


     // TOD:::
// :: Add for Update to insert subjectBillingItems into invoiceItems.
   // :: add the items
//   this.addSubjectInvoiceItem(this.invoiceItemsList2, this.invoice_id);
   // :: Update the status of the subjectBillingItems because we added them to the invoice items database

  //  setTimeout( () => {  }, 0 );


    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 addSubjectBillingItemFromInvoiceUpdate(model) {
  this._demoService.addSubjectBillingItem(model).subscribe(
     data => { this.new_subject_billing_item_id = data;
   //  let res = data[0];

              // Run the insert of insert objects through a loop.
       this.returned_subject_billing_item_id = this.new_subject_billing_item_id.last_insert_id;
       console.log('Returned BID: ' + this.returned_subject_billing_item_id);
      this.toastr.success('Billing Item Added');


// :: make up the item
let tax_percent;
let tax_value = 0;
 if(model.myob_tax_code_id == 1) {
   tax_percent = 10;
   tax_value = (model.billing_task_fee / (100 / tax_percent));
 }
 if(model.myob_tax_code_id == 2) {
   tax_percent = 0;
   tax_value = 0;
 }


      // now add the invoice items
  this.invoiceItemsList2 = {
    invoice_number: this.invoice_number,
    invoice_id: this.invoice_id,
    billing_task_id: model.billing_task_id,
    subject_billing_item_id: this.returned_subject_billing_item_id,
    billing_task_name: model.billing_task_name,
    myob_tax_code_id: model.myob_tax_code_id,
    myob_account_code_id: model.myob_account_code_id,
    billing_task_fee: model.billing_task_fee,
    billing_task_description: model.billing_task_description,
    subject_id: this.subject_id,
    subject_number: this.subject_number,
    job_id: this.job_id,
    job_number: this.job_number,
    qty: 1,
    unit_price: model.billing_task_fee,
    tax: tax_value,
    // total: model.billing_task_fee,
      total: +model.cost_task_fee + +tax_value, // feb 10 2023

          };
 this.addSubjectInvoiceItem(this.invoiceItemsList2, this.invoice_id);


  setTimeout( () => { 

    this.refreshInvoiceItemsBelow.emit(); // refreshed invoice list in below window. from modal template component.
      // :: now hide the invoice modal;
      this.closeParentModel2.emit(null);
   this.refreshParentGrid.emit(); // did not work?
     this.refreshSujectWorkOrderPage(this.subject_id); // so refresh entire page instead.
}, 1500 );
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 
 addSubjectCostItemFromWorkOrderUpdate(model) {

  // console.log('Sent Item(CostItem) to Update Model WorkOrder: ' + JSON.stringify(model));

  this._demoService.addSubjectCostItem(model).subscribe(
     data => { this.new_subject_cost_item_id = data;
   //  let res = data[0];

              // Run the insert of insert objects through a loop.
       this.returned_subject_cost_item_id = this.new_subject_cost_item_id.last_insert_id;
     //  console.log('Returned BID: ' + this.returned_subject_cost_item_id);
      this.toastr.success('Cost Item Added');


// :: make up the item
let tax_percent;
let tax_value = 0;
 if(model.myob_tax_code_id == 1 || model.myob_tax_code_id == 4  )  {
   tax_percent = 10;
   tax_value = (model.cost_task_fee / (100 / tax_percent));
 }else{
//  if(model.myob_tax_code_id == 2) {
   tax_percent = 0;
   tax_value = 0;
 }


      // now add the invoice items
  this.workOrderItemsList2 = {
    work_order_number: this.work_order_number,
    work_order_id: this.work_order_id,
    cost_task_id: model.cost_task_id,
    subject_cost_item_id: this.returned_subject_cost_item_id,
    cost_task_name: model.cost_task_name,
    myob_tax_code_id: model.myob_tax_code_id,
    myob_account_code_id: model.myob_account_code_id,
    cost_task_fee: model.cost_task_fee,
    cost_task_description: model.cost_task_description,
    subject_id: this.subject_id,
    subject_number: this.subject_number,
    job_id: this.job_id,
    job_number: this.job_number,
    qty: 1,
    unit_price: model.cost_task_fee,
    tax: tax_value,
    total: +model.cost_task_fee + +tax_value,
    agent_id: model.agent_id,
    agent_full_name: model.agent_full_name
          };


          // holding work order items list
          // console.log('WorkOrderItemsList2' + JSON.stringify(this.workOrderItemsList2));
           this.addSubjectWorkOrderItem(this.workOrderItemsList2, this.work_order_id);


            setTimeout( () => {
                  this.refreshWorkOrderItemsBelow.emit(); // refreshed invoice list in below window. from modal template component.
                  //   // :: now hide the invoice modal;
                    this.closeParentModel2.emit(null);
                  //  this.refreshParentGrid.emit(); // did not work?
               this.refreshSujectWorkOrderPage(this.subject_id); // so refresh entire page instead.
          }, 1500 );



    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 addSubjectInvoiceItem(model, invoice_id){
  this._demoService.addSubjectInvoiceItem(model, invoice_id).subscribe(
    data => {  this.new_invoice_item_id = data; // this is the retuned json upon creation.
      // let res = data[0];
                      // Run the insert of insert objects through a loop.
                      this.returned_invoice_item_id = this.new_invoice_item_id.last_insert_id;
                      console.log('Returned IIID: ' + this.returned_invoice_item_id);

        let invoice_status = 'INVOICED';
        // tslint:disable-next-line:max-line-length
        this.updateSubjectBillingItemInvoiceStatus(invoice_status, this.returned_subject_billing_item_id, this.invoice_id, this.invoice_number, model);
        this.toastr.success('Invoice Item Added');
    // this.router.navigate(['../../companies'], { relativeTo: this.route });
     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }


 


 addSubjectWorkOrderItem(model, work_order_id){
  this._demoService.addSubjectWorkOrderItem(model, work_order_id).subscribe(
    data => {  this.new_work_order_item_id = data; // this is the retuned json upon creation.
      // let res = data[0];
                      // Run the insert of insert objects through a loop.
                      this.returned_work_order_item_id = this.new_work_order_item_id.last_insert_id;
                     // console.log('Returned IIID: ' + this.returned_work_order_item_id);

        let work_order_status = 'APPLIED';
        // tslint:disable-next-line:max-line-length
        this.updateSubjectCostItemWorkOrderStatusAgentID(work_order_status, this.returned_subject_cost_item_id, this.work_order_id, this.work_order_number, this.agent_id, model);
        this.toastr.success('Work Order Item Added');
    // this.router.navigate(['../../companies'], { relativeTo: this.route });
     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }

// :: 
 updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, invoice_model) {
  this._demoService.updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, invoice_model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });

     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }


 
// :: 
updateSubjectCostItemWorkOrderStatusAgentID(work_order_status, subject_cost_item_id, work_order_id, work_order_number, agent_id, work_order_model) {
  this._demoService.updateSubjectCostItemWorkOrderStatusAgentID(work_order_status, subject_cost_item_id, work_order_id, work_order_number, agent_id, work_order_model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });

     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }




}
